import { render, staticRenderFns } from "./ConsultaSinCita.vue?vue&type=template&id=9d8ff25a"
import script from "./ConsultaSinCita.vue?vue&type=script&lang=js"
export * from "./ConsultaSinCita.vue?vue&type=script&lang=js"
import style0 from "./ConsultaSinCita.vue?vue&type=style&index=0&id=9d8ff25a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports